import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { APICONSTANTS } from "../../constants/api-constants";
import { TypeCompModel } from "../../models/simple-types/type-comp.model";
import { GenericLibelleService } from "../basic/generic-libelle.service";
import { HostnameService } from "../basic/hostname.service";

@Injectable()
export class TypeCompService extends GenericLibelleService<TypeCompModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTETYPECOMP, hostnameService);
  }
}
